import { uiSlice } from "./ui.slice";

const reducerActions = uiSlice.actions;

export const uiActions = {
	...reducerActions,
};
